import './ClientCallout.scss';

const content = {
  title: 'Porque Escolher a Plover?',
  subtitle: 'A Plover é a aliada que o seu negócio precisa na era digital.',
  description:
    'Pequenas empresas, grandes ideias. De padarias a boutiques, oferecemos soluções que aceleram o seu sucesso. Vamos além da tecnologia, oferecendo mais do que apenas ferramentas: oferecemos um parceiro de confiança para o crescimento do seu negócio.',
};

const ClientCallout = () => {
  return (
    <section className="client-callout section">
      <div className="wrapper wrapper--small">
        <h2 className="wrapper__title">{content.title}</h2>
        <h3 className="wrapper__subtitle h4 centered">{content.subtitle}</h3>
        <p className="wrapper__description">{content.description}</p>
      </div>
    </section>
  );
};

export default ClientCallout;